import { adminAPI } from '@/utils/adminApi';
import { tiktokPlatformAPI } from '@/tiktok-platform/api/tiktokPlatformApi';

function normalizeCategoryChildren(res) {
  if (Array.isArray(res)) return res;
  if (Array.isArray(res?.categoryDTOList)) return res.categoryDTOList;
  if (Array.isArray(res?.categories)) return res.categories;
  if (Array.isArray(res?.items)) return res.items;
  if (Array.isArray(res?.result?.categoryDTOList)) return res.result.categoryDTOList;
  if (Array.isArray(res?.data?.categoryDTOList)) return res.data.categoryDTOList;
  if (Array.isArray(res?.data?.categories)) return res.data.categories;
  return [];
}

/**
 * 按父级懒加载 Tiktok 类目（平台全量树过大，店铺同步只缓存一级）。
 * @param {string|number} shopId
 * @returns {(parentNode: object) => Promise<object[]>}
 */
export function createTiktokCategoryChildrenLoader(shopId) {
  return async (parentNode) => {
    const parentId = parentNode?.category_id ?? parentNode?.catId ?? parentNode?.categoryId;
    if (parentId == null || parentId === '') {
      return [];
    }
    const res = await tiktokPlatformAPI.getPublishCategories(shopId, parentId);
    return normalizeCategoryChildren(res);
  };
}

/**
 * 官方模板：按店铺类型借参考店缓存树懒加载下级类目（admin 鉴权，无需店铺工作区）。
 * @param {string} shopType
 * @returns {(parentNode: object) => Promise<object[]>}
 */
export function createTiktokOfficialCategoryChildrenLoader(shopType) {
  return async (parentNode) => {
    const parentId = parentNode?.category_id ?? parentNode?.catId ?? parentNode?.categoryId;
    if (parentId == null || parentId === '') {
      return [];
    }
    const res = await adminAPI.getOfficialTiktokCatalogCategoryChildren({
      shopType,
      parentCatId: parentId,
    });
    return normalizeCategoryChildren(res);
  };
}
